import { Book } from '@/types/book';

/**
 * V1 catalog retired. Returns an empty array so existing consumers stay typed
 * without hitting the dropped `books` table.
 */
export const getBooks = async (): Promise<Book[]> => [];
